export var RebateType;
(function (RebateType) {
    RebateType["BRAND"] = "Brand";
    RebateType["GENERIC"] = "Generic";
})(RebateType || (RebateType = {}));
export var PvaType;
(function (PvaType) {
    // McKesson Contract Types
    PvaType["IPC_OPTION_1"] = "IPC Option 1";
    PvaType["IPC_OPTION_2"] = "IPC Option 2";
    PvaType["IPC_218"] = "IPC 218";
    PvaType["IPC_USAVE"] = "IPC USave";
    PvaType["APCI_STANDARD"] = "APCI Standard";
    PvaType["APCI_GCR_ONLY"] = "APCI GCR Only";
    // Cardinal Contract Types
    PvaType["AAP_STANDARD"] = "AAP Standard";
    PvaType["AAP_ALTERNATIVE"] = "AAP Alternative";
    PvaType["AAP_CORE"] = "AAP Core";
    PvaType["NEXUS"] = "Nexus";
})(PvaType || (PvaType = {}));
export var GcrItemType;
(function (GcrItemType) {
    GcrItemType["SPECIALTY"] = "Specialty";
    GcrItemType["GLP1S"] = "GLP1's";
    GcrItemType["FLU_COVID_VACCINES"] = "Flu and Covid Vaccines";
    GcrItemType["DEXCOM"] = "Dexcom";
    GcrItemType["DROPSHIP"] = "Dropship";
    GcrItemType["MIGRAINE"] = "Migraine";
    GcrItemType["ANTI_DIABETICS"] = "Anti-Diabetics";
    GcrItemType["ANTI_PSYCHOTICS"] = "Anti-Psychotics";
})(GcrItemType || (GcrItemType = {}));
;
